const getLocalShowKOTButton = () => {
  const val = localStorage.getItem("showKOTButton");
  return val === null ? true : val === "true";
};
export default getLocalShowKOTButton;
